var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:_vm.css,attrs:{"type":"button","disabled":_vm.loading},on:{"click":_vm.handleClick}},[(!_vm.loading)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e(),(_vm.img != '' && !_vm.loading)?_c('i',{class:_vm.img}):_vm._e(),(_vm.loading)?_c('div',{staticClass:"spinner-grow spinner-grow-sm text-white"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }